import React from 'react';

const Messages = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Messages</h1>
      <p className="text-gray-600">Messaging system coming soon...</p>
    </div>
  );
};

export default Messages;